import React from "react";
import { motion } from "framer-motion";

const Footer = () => {
  

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footerupper-wrapper">
            <div className="footer-title">
                <h1>DESIGNING SYSTEMS. SIMPLIFYING EXPERIENCES.</h1>
                <p>Focused on structure, clarity, and user-first thinking to build products that feel effortless.</p>
            </div>
            <div className="view-profile">
                <a href="">View Full Profile</a>
            </div>
        </div>

        <div className="lower-footer">
            <div className="ft-cta">LET’S <span className="outline-text">TALK.</span></div>
            <div className="ft-links">
                <a href="mailto:suzambstha@gmail.com" data-cursor-hover="true" aria-label="Email asuzambstha@gmail.com (opens email client)">suzambstha@gmail.com</a>
                <a href="" target="_blank" rel="noopener noreferrer" data-cursor-hover="true">LinkedIn</a>
                <a href="/" target="_blank" rel="noopener noreferrer" data-cursor-hover="true">Instagram</a>
                <a href="" data-cursor-hover="true">Privacy</a>
                <span className="ft-copyright">© 2026  Suzam Shrestha. All rights reserved.</span>
            </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;